import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import useActionPending from "@hooks/useActionPending";
import CustomMetadataRead from "@features/dialog/custom-metadata/custom-metadata-read";
import SelectDialogWrapper from "@features/dialog/select-dialog-wrapper";

const DialogSelectCustomMetadata = ({
    disableDialog,
    contentSchemaId,
    onClickClose,
    onClickSubmit,
    onChangeCustomMetadata,
}) => {
    const { t } = useTranslation();
    const [contentSchemaDetail, setContentSchemaDetail] = useState();

    const {
        pending: isSubmitPending,
        setActionPending: submitPending,
        disableActionPending: disableSubmitPending,
    } = useActionPending("updateCustomMetadata");

    const handleSelectedMetadata = async (customMetadata) => {
        setContentSchemaDetail(customMetadata);
        if (onChangeCustomMetadata) {
            onChangeCustomMetadata(customMetadata);
        }
    };

    const onHandleClickSubmit = async () => {
        try {
            submitPending();
            await onClickSubmit(contentSchemaDetail);
            disableSubmitPending();
            onClickClose();
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <SelectDialogWrapper
            variant="expandable"
            t={t}
            disableDialog={disableDialog}
            title={"Select custom metadata"}
            isSubmitButtonDisabled={!contentSchemaDetail || isSubmitPending}
            onHandleSubmit={onHandleClickSubmit}
            onClose={() => onClickClose()}
            open={true}
            minwidth={768}
            maxWidth={"fit-content"}
            sx={{ "& .MuiDialog-paper": { height: "743px", maxWidth: "768px" } }}
        >
            <CustomMetadataRead
                warningMessage={t(
                    `common::msg::If you change the applied custom metadata, all data entered will be lost.`,
                )}
                contentSchemaId={contentSchemaId}
                contentSchemaDetail={contentSchemaDetail}
                onSelectCustomMetadata={handleSelectedMetadata}
            />
        </SelectDialogWrapper>
    );
};
export default DialogSelectCustomMetadata;
